/* src/components/Breadcrumbs.jsx - Última Modificación: 12-01-2026 */
/* ---------------------------------------------------------------- */

import {
  useLocation,
  Link as RouterLink,
} from 'react-router-dom';

import {
  Breadcrumbs as MUIBreadcrumbs,
  Typography,
  Link,
  Box,
  Stack
} from '@mui/material';

import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import { getBreadcrumbFromSidebar } from './utils/getBreadcrumbFromSidebar';

import { RiHome8Line } from "react-icons/ri";

const routeLabels = {
  "/libroventascli": "Libro de Ventas",
  "/librocomprascli": "Libro de Compras",
  "/cesionesdeu": "Cesiones",
  "/compagos": "En Nómina de Pagos",
  "/rentascli": "Rentas F22",
  "/djcli": "Declaraciones Juradas",
};


const Breadcrumbs = () => {

  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const fromDashboard =
    location.state?.from === "dashboard" ||
    params.get("from") === "dashboard";

  const pathname = location.pathname;

  const currentLabel =
    routeLabels[pathname] || "Detalle";


  let trail;

  if (fromDashboard) {
    trail = [
      { label: "Dashboard", link: "/dashboard" },
      { label: currentLabel }
    ];
  } else {
    trail = getBreadcrumbFromSidebar(pathname).trail;
  }

  if (!trail?.length) return null;

  return (
    <Box
      sx={theme => ({
        position: 'sticky',
        top: 64,
        zIndex: 1100,
        px: 2,
        py: 0.75,
        backgroundColor: theme.custom.ui.breadcrumbBg,
        borderBottom: `1px solid ${theme.custom.ui.borderSubtle}`,
      })}
    >
      <MUIBreadcrumbs
        aria-label="breadcrumb"
        separator={
          <NavigateNextIcon
            fontSize="small"
            sx={{ color: 'text.disabled' }}
          />
        }
      >
        {trail.map((item, index) => {
          const isLast = index === trail.length - 1;
          const isHome = item.label === 'Inicio';

          const content = (
            <Stack direction="row" spacing={0.5} alignItems="center">
              {isHome && (
                <RiHome8Line
                  size={14}
                  style={{ opacity: 0.8 }}
                />
              )}
              <span>{item.label}</span>
            </Stack>
          );

          return isLast ? (
            <Typography
              key={index}
              component="div"
              sx={{
                fontSize: '0.8rem',
                fontWeight: 600,
                color: 'text.primary',
              }}
            >
              {content}
            </Typography>
          ) : (
            <Link
              key={index}
              component={RouterLink}
              to={item.link || '#'}
              sx={(theme) => ({
                fontSize: '0.75rem',
                color: theme.palette.text.secondary,
                textDecoration: 'none',
                '&:hover': {
                  color: theme.custom.ui.titleAccent,
                  textDecoration: 'underline',
                },
              })}
            >
              {content}
            </Link>
          );
        })}
      </MUIBreadcrumbs>
    </Box>
  );
};

export default Breadcrumbs;
